import * as moment from 'moment';
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from "react-redux";
import { MailService } from "../../services/mail";
import UserSettings from '../settings/model/Settings';
import Message from './model/Message';

interface ISelectedMessagesPreviewProps {
  messageList: Message[];
  settings: UserSettings;
}

export class SelectedMessagesPreview extends React.Component<ISelectedMessagesPreviewProps> {
  public mailService: MailService;

  constructor(props: ISelectedMessagesPreviewProps) {
    super(props);
  }

  public render() {
    const dateFormat = this.props.settings.dateFormat ? this.props.settings.dateFormat.toUpperCase() + ' hh:mm A' : 'MM/DD/YYYY hh:mm A';
    const selectedMessages = this.props.messageList
      .filter((m) => m.selected)
      .map((message) => {
        return (
          <tr className="email-item row" key={message.id}>
            <td className="text from col-sm-2"><span className="normal">{message.headers.from}</span></td>
            <td className="text to col-sm-2"><span className="normal">{message.headers.to}</span></td>
            <td className="text col-sm-6"><span className="normal">&lt;{message.headers.subject}&gt;</span></td>
            <td className="text col-sm-2"><span className="normal">{moment(message.headers.date).format(dateFormat)}</span></td>
          </tr>
        )
      });

    return (
      <div className="selected-emails desktop">
        <div className="row">
          <div className="col-12">
            <h3><FormattedMessage id="L.SelectedMessages" defaultMessage="Selected Messages" /></h3>
          </div>
        </div>
        <div className="table-responsive col-12">
          <table className="table">
            <thead>
              <tr className="row">
                <th className="text col-sm-2" scope="col"><span><FormattedMessage id="L.From" defaultMessage="From" /></span></th>
                <th className="text col-sm-2" scope="col"><span><FormattedMessage id="L.To" defaultMessage="To" /></span></th>
                <th className="text col-sm-6" scope="col"><span><FormattedMessage id="L.Subject" defaultMessage="Subject" /></span></th>
                <th className="text col-sm-2" scope="col"><span><FormattedMessage id="L.Sent" defaultMessage="Sent" /></span></th>
              </tr>
            </thead>
            <tbody>
              {selectedMessages}
            </tbody>
          </table>
        </div>
      </div>)
  }
}

const mapStateToProps = (state: any) => {
  return {
    messageList: state.mail.messageList,
    settings: state.settings.settings,
  };
}

export default connect(mapStateToProps)(SelectedMessagesPreview);


// WEBPACK FOOTER //
// ./src/components/mail/SelectedMessagesPreview.tsx